"use client";

import React from "react";

const TitleComponent: React.FC = () => {
  return (
    <>
      <div className="blog-area pt-100 pb-75 w-100">
        <div className="container-fluid container-flex-center">
          <div className="section-title w-75" style={{maxWidth: "90%"}}>
            <p className="sub-title">
              En <strong>DISTRIBUIDORA ALIADOS</strong> tenemos un equipo capacitado y dispuesto
              a ofrecer asesoría a sus preguntas, puede contactarnos para
              ofrecerle nuestra ayuda:
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TitleComponent;
